import axios from '@api';
import type { AxiosResponse } from 'axios';

import { transformSurveyGPT } from './utilities/helpers';
import type { SurveyGPTResponse } from './types';

/**
 * create survey GPT feedback
 */
export const createSurveyGPTFeedback = async ({
  feedback,
  note,
  signal,
  surveyGPTJobId,
}: {
  feedback: 'NEGATIVE' | 'POSITIVE';
  note?: string;
  signal?: AbortSignal;
  surveyGPTJobId: number;
}) => {
  return axios({
    data: {
      feedback,
      note,
    },
    method: 'post',
    signal,
    url: `/api/surveygpt/${surveyGPTJobId}/feedback`,
    withCredentials: true,
  });
};

/**
 * read survey GPT
 */
export const readSurveyGPT = async ({
  signal,
  surveyGPTJobId,
  userId: user_id,
}: {
  signal?: AbortSignal;
  surveyGPTJobId: number;
  userId?: number;
}) => {
  return axios({
    method: 'get',
    params: {
      user_id,
    },
    signal,
    url: `/api/surveygpt/${surveyGPTJobId}`,
    withCredentials: true,
  }).then(({ data }: AxiosResponse<SurveyGPTResponse>) => transformSurveyGPT(data));
};
